<template>
  <navbar />
  <!-- partial -->
  <div class="container-fluid page-body-wrapper">

    <sidebar />

    <div class="main-panel">
      <div class="content-wrapper">
        <div class="row">
          <div class="col-lg-12 grid-margin stretch-card px-0">
            <div class="card">
              <div class="card-body">
                <div class="row col-md-9 mb-4">
                    <div class="d-flex flex-wrap gap-3">
                        <!-- <button class="btn btn-success text-white py-2 px-4" style="border-radius: 6%;" @click="exportCitizens()" :disabled="isExporting">{{ isExporting ? 'Exporting...' : 'Export Data' }}</button> -->
                         <button
  class="btn btn-success text-white py-2 px-4"
  style="border-radius: 6%;"
  :disabled="isExporting"
  @click="exportCitizens"
>
  <span v-if="isExporting">
    <i class="fa fa-spinner fa-spin"></i> Exporting...
  </span>
  <span v-else>Export Data</span>
</button>

                        <!-- <button class="btn text-white py-2 px-4" style="background-color: #52adf2; border-radius: 6%;">Generate Selected Citizen QR Code</button> -->
                        <button class="btn text-white py-2 px-4" style="background-color: #007bff; border-radius: 6%;" data-bs-toggle="modal" data-bs-target="#addModal">Add House Hold and Others</button>
                        <!-- <button class="btn btn-warning py-2 px-4" style="border-radius: 6%;" data-bs-toggle="modal" data-bs-target="#exampleModal3">Search Filter</button> -->
                    </div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-md-2">
                    <input type="text" class="form-control form-control-sm" v-model="searchForm.wardNo" placeholder="Ward No">
                  </div>
                  <div class="col-md-2">
                    <input type="text" class="form-control form-control-sm" v-model="searchForm.roadName" placeholder="Road Name">
                  </div>
                  <div class="col-md-2">
                    <input type="text" class="form-control form-control-sm" v-model="searchForm.block" placeholder="Block Name">
                  </div>
                  <div class="col-md-1">
                    <button class="btn btn-success btn-block btn-sm text-white" style="border-radius: 6%;" @click="searchCitizen">Search</button>
                  </div>
                  <div class="col-md-1">
                    <button class="btn btn-danger btn-block btn-sm text-white" style="border-radius: 6%;" @click="resetCitizen">Reset</button>
                  </div>

                </div>
                <!-- <div class="row mb-3 align-items-center">
                    <div class="col-md-6">
                        <div class="d-flex align-items-center">
                            <label for="entriesSelect" class="me-2">Show</label>
                            <select id="entriesSelect" class="form-select-sm w-auto">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            <span class="ms-2">entries</span>
                        </div>
                    </div>
                    <div class="col-md-6 d-flex align-items-center justify-content-end">
                        <label for="searchInput" class="me-2 form-label mb-0">Search:</label>
                        <input id="searchInput" type="text" class="form-control form-control-sm w-auto">
                    </div>
                </div> -->
                <div class="table-responsive">
                  <table class="table table-striped table-borderless">
                    <thead style="border-top: 1px solid grey; border-bottom: 1px solid grey;">
                      <tr>
                        <th>Sl No.</th>
                        <th>Enumeration No.</th>
                        <th>Property Type</th>
                        <th>HOF Name</th>
                        <th>Contact No</th>
                        <th>Ownership Type</th>
                        <th>Road Name</th>
                        <th>Ward No</th>
                        <th>Block</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="citizenList != null">
                      <tr v-for="(data, index) in citizenList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td class="font-weight-bold"><strong>{{ data.enumerationNo }}</strong></td>
                        <td v-if="data.propertyType == 'IH'">
                          Residential
                        </td>
                        <td v-else-if="data.propertyType == 'IHS'">
                          Residential Cum Commercial
                        </td>
                        <td v-else-if="data.propertyType == 'INS'">
                          Institution -  {{ data.otherValue }} ({{ data.propertyTypeFor }})
                        </td>
                        <td v-else-if="data.propertyType == 'RP'">
                          Religious Place
                        </td>
                        <td v-else-if="data.propertyType == 'IND'">
                          Industries -  {{ data.otherValue }} ({{ data.propertyTypeFor }})
                        </td>
                        <td v-else-if="data.propertyType == 'OTH'">
                          {{ data.otherValue }} ({{ data.propertyTypeFor }})
                        </td>
                        <td>{{ data.hofName }}</td>
                        <td>{{ data.mobileNo }}</td>
                        <td v-if="data.ownershipType == 'OWN'">Owner</td>
                        <td v-else-if="data.ownershipType == 'TNT'">Tenant</td>
                        <td v-else-if="data.ownershipType == 'CMT'">Committee</td>
                        <td>{{ data.roadName}}</td>
                        <td>{{ data.wardNo }}</td>
                        <td>{{ data.block }}</td>
                        <td>
                            <div class="dropdown">
                            <a href="#" class="text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fa-solid fa-gear fa-lg" style="color: #63452c;"></i>                            </a>
                                <ul class="dropdown-menu">
                                    <li><button class="dropdown-item" data-bs-toggle="modal" :data-bs-target="'#edit-citizen'+index" @click="editCitizen(data.id)">Edit</button></li>
                                    <li><a class="dropdown-item" href="#">Delete</a></li>
                                </ul>
                            </div>
                             <!-- Edit Citizen modal -->
                            <div class="modal fade" :id="'edit-citizen'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog custom-md-model"> <!-- Apply the custom class here -->
                                  <form class="form" @submit.prevent="updateCitizen(data.id,index)">
                                    <div class="modal-content">

                                    <!-- Modal Header -->
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Edit House Hold and Others (EM No. :  {{ data.enumerationNo }} )</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>

                                    <!-- Modal Body -->
                                    <div class="modal-body px-4">
                                      <div class="row">
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Ward:</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.wardId" @change="getRoad($event)">
                                            <option selected disabled>Select Ward</option>
                                            <option v-for="ward in wardList" :key="ward.id" :value="ward.id" class="color-mg">
                                              {{ward.name}}
                                            </option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Road:</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.roadId" @change="getBlock($event)" :disabled="isDisabledOne">
                                            <option selected disabled>Select Road</option>
                                            <option v-for="road in roadList" :key="road.id" :value="road.id" class="color-mg">
                                              {{road.name}}
                                            </option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Block:</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.blockId" :disabled="isDisabledTwo">
                                            <option selected disabled>Select Block</option>
                                            <option v-for="block in blockList" :key="block.id" :value="block.id" class="color-mg">
                                              {{block.name}}
                                            </option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Property Type:</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.propertyType">
                                            <!-- <option selected disabled>Select House / Shop</option> -->
                                            <option value="IH">Residential (IH)</option>
                                            <option value="IHS">Residential Cum Commercial (IHS)</option>
                                            <option value="INS">Institution (INS)</option>
                                            <option value="RP">Religious Place (RP)</option>
                                            <option value="IND">Industries (IND)</option>
                                            <option value="OTH">Others (OTH)</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'OTH'">
                                          <label class="form-label fw-bold">Please specify :</label>
                                          <input type="text" class="form-control form-control-sm" v-model="citizenForm.otherValue">
                                        </div>
                                        <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'OTH'">
                                          <label class="form-label fw-bold">Type :</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.propertyTypeFor">
                                            <!-- <option selected disabled>Select House / Shop</option> -->
                                            <option value="PVT">Private</option>
                                            <option value="GOVT">Government</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'IND'">
                                          <label class="form-label fw-bold">Type :</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.propertyTypeFor">
                                            <!-- <option selected disabled>Select House / Shop</option> -->
                                            <option value="PVT">Private</option>
                                            <option value="GOV">Government</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'INS'">
                                          <label class="form-label fw-bold">Type :</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.propertyTypeFor">
                                            <!-- <option selected disabled>Select House / Shop</option> -->
                                            <option value="PVT">Private</option>
                                            <option value="GOVT">Government</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Name of the HOF/HOI/HOC :</label>
                                          <input type="text" class="form-control form-control-sm" v-model="citizenForm.hofName">
                                        </div>
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Ownership Type:</label>
                                          <select class="form-select form-select-sm" v-model="citizenForm.ownershipType">
                                            <option selected disabled>Select Ownership Type</option>
                                            <option v-if="citizenForm.propertyType != 'RP'" value="OWN">Owner (OWN)</option>
                                            <option v-if="citizenForm.propertyType != 'RP'" value="TNT">Tenant (TNT)</option>
                                            <option v-if="citizenForm.propertyType == 'RP'" value="CMT">Committee (CMT)</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 form-group mb-3">
                                          <label class="form-label fw-bold">Contact No :</label>
                                          <input type="text" class="form-control form-control-sm"  v-model="citizenForm.mobileNo">
                                        </div>
                                      </div>
                                    </div>

                                    <!-- Modal Footer -->
                                    <div class="modal-footer">
                                      <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                                      <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;">Update</button>
                                    </div>

                                    </div>
                                  </form>
                                </div>
                            </div>
                        </td>

                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="13" style="text-align: center; font-size: 18px;color: #de0723;">No Data Found !</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="p-2" v-if="this.searchPagination == false">
                      <pagination v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :offset="10"
                      @paginate="getCitizens()">
                      </pagination>
                  </div>
                  <div v-else>
                      <pagination v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :offset="10"
                      @paginate="searchCitizen()">
                      </pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!-- content-wrapper ends -->
      <!-- partial:partials/_footer.html -->
      <footer class="footer">
        <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023. Premium <a href="" target="_blank"></a> All rights reserved.</span>
            <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"></span>
        </div>
      </footer>
      <!-- partial -->
    </div>

    <!-- Import Citizen modal -->
    <div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog custom-small-modal"> <!-- Apply the custom class here -->
            <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Import Citizen Form</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body px-4">
                <form>
                <div class="form-group mb-3">
                <label class="form-label fw-bold">Ward:</label>
                <select class="form-select form-select-sm">
                    <option selected disabled>Select Ward</option>
                    <option value="1">Ward 1</option>
                    <option value="2">Ward 2</option>
                    <option value="3">Ward 3</option>
                </select>
                </div>
                <div class="form-group mb-3">
                <label class="form-label fw-bold">Road:</label>
                <select class="form-select form-select-sm">
                    <option selected disabled>Select Road</option>
                    <option value="A">Road A</option>
                    <option value="B">Road B</option>
                    <option value="C">Road C</option>
                </select>
                </div>
                <div class="form-group mb-3">
                <label class="form-label fw-bold">Block:</label>
                <select class="form-select form-select-sm">
                    <option selected disabled>Select Block</option>
                    <option value="X">Block X</option>
                    <option value="Y">Block Y</option>
                    <option value="Z">Block Z</option>
                </select>
                </div>
                <div class="mb-3">
                    <label class="form-label fw-bold">Import File: <a href="#"><small class="text-primary">(download sample file)</small></a></label>
                    <div class="d-flex align-items-center">
                        <input type="file" class="form-control form-control-sm w-100" style="padding: 0.8rem 0.81rem;"/>

                    </div>
                </div>
                </form>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                <button type="button" class="btn btn-success text-white py-2" style="border-radius: 6%;">Save</button>

            </div>

            </div>
        </div>
    </div>

    <!-- Add New Citizen modal -->
    <div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog custom-md-model"> <!-- Apply the custom class here -->
          <form class="form" @submit.prevent="addCitizen()">
            <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">New House Hold and Others</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body px-4">

                <div class="row">
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Ward:</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.wardId" @change="getRoad($event)">
                      <option selected disabled>Select Ward</option>
                      <option v-for="ward in wardList" :key="ward.id" :value="ward.id" class="color-mg">
                        {{ward.name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Road:</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.roadId" @change="getBlock($event)" :disabled="isDisabledOne">
                      <option selected disabled>Select Road</option>
                      <option v-for="road in roadList" :key="road.id" :value="road.id" class="color-mg">
                        {{road.name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Block:</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.blockId" :disabled="isDisabledTwo">
                      <option selected disabled>Select Block</option>
                      <option v-for="block in blockList" :key="block.id" :value="block.id" class="color-mg">
                        {{block.name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Property Type:</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.propertyType">
                      <!-- <option selected disabled>Select House / Shop</option> -->
                      <option value="IH">Residential (IH)</option>
                      <option value="IHS">Residential Cum Commercial (IHS)</option>
                      <option value="INS">Institution (INS)</option>
                      <option value="RP">Religious Place (RP)</option>
                      <option value="IND">Industries (IND)</option>
                      <option value="OTH">Others (OTH)</option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'OTH'">
                    <label class="form-label fw-bold">Please specify :</label>
                    <input type="text" class="form-control form-control-sm" v-model="citizenForm.otherValue">
                  </div>
                  <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'OTH'">
                    <label class="form-label fw-bold">Type :</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.propertyTypeFor">
                      <!-- <option selected disabled>Select House / Shop</option> -->
                      <option value="PVT">Private</option>
                      <option value="GOVT">Government</option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'IND'">
                    <label class="form-label fw-bold">Type :</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.propertyTypeFor">
                      <!-- <option selected disabled>Select House / Shop</option> -->
                      <option value="PVT">Private</option>
                      <option value="GOV">Government</option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3" v-if="this.citizenForm.propertyType == 'INS'">
                    <label class="form-label fw-bold">Type :</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.propertyTypeFor">
                      <!-- <option selected disabled>Select House / Shop</option> -->
                      <option value="PVT">Private</option>
                      <option value="GOVT">Government</option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Name of the HOF/HOI/HOC :</label>
                    <input type="text" class="form-control form-control-sm" v-model="citizenForm.hofName">
                  </div>
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Ownership Type:</label>
                    <select class="form-select form-select-sm" v-model="citizenForm.ownershipType">
                      <option selected disabled>Select Ownership Type</option>
                      <option v-if="citizenForm.propertyType != 'RP'" value="OWN">Owner (OWN)</option>
                      <option v-if="citizenForm.propertyType != 'RP'" value="TNT">Tenant (TNT)</option>
                      <option v-if="citizenForm.propertyType == 'RP'" value="CMT">Committee (CMT)</option>
                    </select>
                  </div>
                  <div class="col-md-6 form-group mb-3">
                    <label class="form-label fw-bold">Contact No :</label>
                    <input type="text" class="form-control form-control-sm"  v-model="citizenForm.mobileNo">
                  </div>
                </div>

            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
              <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;">Save</button>
            </div>

            </div>
          </form>
        </div>
    </div>


    <!-- Search Modal -->
    <!-- <div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog custom-small-modal">
            <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Import Citizen Form</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body px-4">
                <form>
                <div class="form-group mb-3">
                <label class="form-label fw-bold">Ward:</label>
                <select class="form-select form-select-sm">
                    <option selected disabled>Select Ward</option>
                    <option value="1">Ward 1</option>
                    <option value="2">Ward 2</option>
                    <option value="3">Ward 3</option>
                </select>
                </div>
                <div class="form-group mb-3">
                <label class="form-label fw-bold">Road:</label>
                <select class="form-select form-select-sm">
                    <option selected disabled>Select Road</option>
                    <option value="A">Road A</option>
                    <option value="B">Road B</option>
                    <option value="C">Road C</option>
                </select>
                </div>
                <div class="form-group mb-3">
                <label class="form-label fw-bold">Block:</label>
                <select class="form-select form-select-sm">
                    <option selected disabled>Select Block</option>
                    <option value="X">Block X</option>
                    <option value="Y">Block Y</option>
                    <option value="Z">Block Z</option>
                </select>
                </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Close</button>
                <button type="button" class="btn btn-success text-white py-2" style="border-radius: 6%;">Search</button>

            </div>

            </div>
        </div>
    </div>  -->


    <!-- main-panel ends -->
  </div>
</template>
<script>
  import Navbar   from '../layouts/navbar.vue';
  import Sidebar  from '../layouts/sidebar.vue';
  import Api      from '../util/Api';
  import Chokidar from '../util/Chokidar';
  import Pagination   from '../util/Pagination.vue'

  export default {
    components: {
      navbar: Navbar,
      sidebar: Sidebar,
      pagination: Pagination
    },
    data() {
      return {

        isLoading : false,
        isExporting: false,

        citizenForm:{
          enumerationNo    : '',
          propertyType     : '',
          propertyTypeFor  : '',
          otherValue       : '',
          hofName          : '',
          mobileNo         : '',
          ownershipType    : '',
          usageCharges     : '',
          usageChargeDate  : '',
          roadId           : '',
          wardId           : '',
          blockId          : '',
          latLong          : '',
        },

        wardList : [{}],
        roadList : [{}],
        blockList : [{}],
        citizenList : [{}],

        pagination: {
          current_page: 1,
        },

        isDisabledOne : true,
        isDisabledTwo : true,

        searchPagination : false,

        searchForm:{
          wardNo   : '',
          roadName : '',
          block    : ''
        }

      }
    },

    methods:{
      getWards(){
        Api().get('/ward-list')
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('guard');
            this.$swal({
              icon: 'error',
              title: 'Session Expired, please login!',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 4000
            });
            this.$router.push('/login');
          }
        }).then(response =>{
          this.wardList = response.data.data;
        });
      },

      getRoad(event){
        if(event)
        {
          Api().get('/road-list/'+event.target.value)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            }
          }).then(response =>{
            this.isDisabledOne = false;
            this.roadList = response.data.data;
          });
        }
      },

      getBlock(event){
        if(event)
        {
          Api().get('/block-list/'+event.target.value)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            }
          }).then(response =>{
            this.isDisabledTwo = false;
            this.blockList = response.data.data;
          });
        }
      },

      addCitizen()
      {
        Api().post('/add-citizen',this.citizenForm)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            }
          }).then(response =>{
            if(response.data['success'] == true)
            {
              this.getCitizens();
              this.citizenForm ={
                enumerationNo    : '',
                propertyType     : '',
                propertyTypeFor  : '',
                otherValue       : '',
                hofName          : '',
                mobileNo         : '',
                ownershipType    : '',
                usageCharges     : '',
                usageChargeDate  : '',
                wardId           : '',
                roadId           : '',
                blockId          : '',
              };
              $('#addModal').modal('hide');
              this.$swal({
                  icon: 'success',
                  title: ' '+response.data['message'],
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
              });
            }
          });
      },

      editCitizen(id)
        {
            Api().get('/edit-citizen/'+id)
              .catch((error) => {
                  if (error.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('guard');
                    this.$swal({
                      icon: 'error',
                      title: 'Session Expired please login!',
                      toast: true,
                      position: 'top-end',
                      showConfirmButton: false,
                      timer: 4000
                    });
                    this.$router.push('/admin/login');
                  }
                }).then((response) => {
                if(response.data != '')
                {
                  Api().get('/road-list/'+response.data.wardId)
                    .catch((error) => {
                      if (error.response.status == 401) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('guard');
                        this.$swal({
                          icon: 'error',
                          title: 'Session Expired, please login!',
                          toast: true,
                          position: 'top-end',
                          showConfirmButton: false,
                          timer: 4000
                        });
                        this.$router.push('/login');
                      }
                    }).then(response =>{
                      this.roadList = response.data.data;
                    });
                    Api().get('/block-list/'+response.data.roadId)
                    .catch((error) => {
                      if (error.response.status == 401) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('guard');
                        this.$swal({
                          icon: 'error',
                          title: 'Session Expired, please login!',
                          toast: true,
                          position: 'top-end',
                          showConfirmButton: false,
                          timer: 4000
                        });
                        this.$router.push('/login');
                      }
                    }).then(response =>{
                      this.blockList = response.data.data;
                    });
                    this.citizenForm.propertyType = response.data.citizen.propertyType;
                    this.citizenForm.otherValue = response.data.citizen.otherValue;
                    this.citizenForm.propertyTypeFor = response.data.citizen.propertyTypeFor;
                    this.citizenForm.hofName = response.data.citizen.hofName;
                    this.citizenForm.mobileNo = response.data.citizen.mobileNo;
                    this.citizenForm.ownershipType = response.data.citizen.ownershipType;
                    this.citizenForm.roadId      = response.data.citizen.roadId;
                    this.citizenForm.wardId        = response.data.citizen.wardId;
                    this.citizenForm.blockId         = response.data.citizen.blockId;
                    this.citizenForm.usageCharges  = response.data.citizen.usageCharges;
                    this.citizenForm.usageChargeDate = response.data.citizen.usageChargeDate;
                }
           });
      },

      updateCitizen(id,index)
      {
          Api().post('/update-citizen/'+id,this.citizenForm)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            }
          }).then(response =>{
            if(response.data['success'] == true)
            {
              this.getCitizens();
              this.citizenForm ={
                enumerationNo    : '',
                propertyType     : '',
                otherValue       : '',
                hofName          : '',
                mobileNo         : '',
                ownershipType    : '',
                usageCharges     : '',
                usageChargeDate  : '',
                roadName         : '',
                wardNo           : '',
                block            : '',
              };
              $('#edit-citizen'+index).modal('hide');
              this.$swal({
                  icon: 'success',
                  title: ' '+response.data['message'],
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
              });
            }
          });
      },

      getCitizens()
      {
        this.isLoading = true;
        this.searchPagination = false;
        Api().get('/all-citizen?page='+this.pagination.current_page)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            }
          }).then(response =>{
            console.log(response)

              this.isLoading = false;
              this.citizenList = response.data.data;
              this.pagination  = response.data.meta;

          });
      },

      searchCitizen()
      {
          this.searchPagination = true;
          Api().post('/search-citizen?page='+this.pagination.current_page,this.searchForm)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            }
          }).then(response =>{
            console.log(response)

              this.isLoading = false;
              this.citizenList = response.data.data;
              this.pagination  = response.data.meta;

          });
      },


     exportCitizens() {
        if(this.isExporting) return;
        this.isExporting = true;

        Api().get('/export-citizens', { responseType: 'blob' }) // Important for binary data


            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                link.setAttribute('download', 'citizens.csv');

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(err => {
                if (err.response && err.response.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('guard');
                    this.$swal({
                        icon: 'error',
                        title: 'Session Expired, please login!',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 4000
                    });
                    this.$router.push('/login');
                } else {
                    console.error('Export failed:', err);
                }
            })
            .finally(() => {
          this.isExporting = false; // unfreeze button
        });
    },


      resetCitizen(){
        this.searchForm={
          wardNo   : '',
          roadName : '',
          block    : ''
        },
        this.getCitizens();
      }
    },
    created()
    {
      if(Chokidar() != 'user'){
        this.$router.push('/login');
      }else{
        this.getCitizens();
        this.getWards();
      }
    }
  }
</script>
